import { efectoresImportLogActions } from './actions';
import { EfectorImportLog } from './efector-import-log';


export const efectoresImportLogReducer = (state = new EfectorImportLog(), { payload, type }) => {

    switch (type) {
        case efectoresImportLogActions.FETCH_EFECTORES_IMPORT_FAILED:
            return state.merge({
                isPending: false,
                error: payload.error
            });

        case efectoresImportLogActions.FETCH_EFECTORES_IMPORT_SUCCESS:
            console.log(payload)
            return state.merge({
                data: payload.data,
                error: payload.error,
                isPending: false,
            });

        case efectoresImportLogActions.FETCH_EFECTORES_IMPORT_PENDING:
            return state.set('isPending', true);
        default:
            return state;
    }
}
